export default "__VITE_ASSET__DtxjosCx__"